<template>
    <transition name="fade">
      <div v-if="visible" class="fixed" @click="closePopup">
        <div class="bg-white" @click="($event) => $event.stopPropagation()">
          <h1 class="title">{{ props.paymentInfo.created_date }} - {{ formatAmount(props.paymentInfo.amount) }}€</h1>
          <p style="text-align: center; font-size: 14px; color: var(--text-color-light);">Estos son los movimientos incluidos en este pago:</p>
          <table>
            <thead>
              <tr>
                <th style="width: 75%;">Descripción</th>
                <th style="width: 25%;">Cantidad</th>
              </tr>
            </thead>
            <tbody>
              <tr 
              v-for="(item, index) in movements"
                :key="index"
                :class="index % 2 === 0 ? 'bg-gray-100' : 'bg-white'"
                @click="purchaseClicked(item)"
              >
                <td style="width: 75%;">{{ item.description }}</td>
                <td style="width: 25%;">{{ formatAmount(item.amount / 100) }}€</td>
              </tr>

            </tbody>
          </table>
        </div>
      </div>
    </transition>
  </template>
  
  <script setup>
  import { ref, watch, defineProps } from 'vue';

  const props = defineProps({
    paymentInfo: Object,
    movements: Object,
  });
  
  const visible = ref(false);

  watch(() => props.paymentInfo, (newVal) => {
    visible.value = !!newVal;
  });
  
  const closePopup = () => {
    visible.value = false;
    history.back();
  };

  function formatAmount(valor) {
    return new Intl.NumberFormat('es-ES', { 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2 
    }).format(valor);
  }

  </script>
  
  <style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  
  .fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 10;
  }
  
  .bg-white {
    background-color: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    width: 80%;
    max-width: 800px;
    max-height: 90vh;
    overflow-y: auto;
  }
  
  .title {
    border-bottom: 1px solid var(--very-clear-gray);
    text-align: center;
    margin-top: 0px;
  }

  table {
  border-radius: 10px;
  overflow: hidden;
  margin-top: 30px;
  width: 100%;
  border-collapse: collapse;
}

th {
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: var(--gray);
  color: white;
  width: 25%;
  border: 0px;
}

tr{
  cursor: pointer;
}

td {
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
}

.bg-gray-100 {
  background-color: var(--almost-white);
}

.bg-white {
  background-color: white;
}

  </style>
  